import React, { Component } from 'react';
import { Label, Input, Button } from 'reactstrap';
import Select from 'react-select';
import { isMobile } from '../../../utils/deviceInfo';
import {isTrivvyProduct, roleOptions} from '../../../utils/constants';


export default class OfficeSetupMember extends Component {

    constructor(props) {
        super(props);
        this.state = {
            firstName: false,
            lastName:false,
            email:'',
            mobileNumber:'',
            fName:'',
            lName:''
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.memberData && !this.props.memberData) {
            this.setState({
                firstName: false,
                lastName: false,
                email: '',
                mobileNumber: '',
                fName: '',
                lName: ''
            });
        }
    }

    render() {
        let specialChar = /[~`!#$%\^&*+=\\[\]\\';,/{}|\\":<>\?0-9]/g
        let props = this.props
        console.log(this.props)
        let {firstName, lastName, fName, lName, email, mobileNumber}=this.state

        // Use the raw stored role for new invitees. manageRoleText expects
        // orgAdmin on saved users and returns "User" as fallback, which would
        // otherwise make the "Enterprise Admin" option appear un-selectable
        // in this invite form.
        const roleValue = (props.memberData && props.memberData.role) || "User";

        // InviteOfficeMates passes mobileFullForm so the phone layout shows every
        // field (Role/Email/Mobile + First/Last) as a stacked, labeled card. Other
        // consumers (AddMembers, InviteAdminsTrivvy) keep the original behavior: no
        // inline labels/caption, and First/Last name hidden on mobile.
        const mobileFullForm = props.mobileFullForm === true
        const showNameFields = mobileFullForm || !isMobile

        return (
        <div className="row invite-member-row" style={{marginTop:20}}>
            {mobileFullForm && <div className="invite-member-caption">Invitee {props.id + 1}</div>}
            <div className="col">
                {mobileFullForm && <Label className="invite-m-label">Role</Label>}
                <Select name="role" 
                  options={roleOptions
                    //   this.props.user.role==='Member'? roleOptions.filter(e=> e.value=='Member'):roleOptions
                    } 
                  value={roleValue}
                  simpleValue
                  clearable={false}
                //   disabled={isTrivvyProduct}
                onChange={(value) => props.onInputChange(props.id,{name : 'role',value : value})}/>
            </div>
            <div className="col">
                {mobileFullForm && <Label className="invite-m-label">Email</Label>}
                <Input type="email" name="email"
                value={props.memberData ? email:''}
                    placeholder="e.g. jane@doe.com"
                    onChange={({target}) => {
                        this.setState({email: target.value})
                        props.onInputChange(props.id,target)
                    }}
                />
            </div>
            <div className="col">
                {mobileFullForm && <Label className="invite-m-label">Mobile Number</Label>}
                <Input type="tel" name="mobileNumber"
                value={props.memberData ? mobileNumber:''}
                    placeholder="e.g. +1234567890"
                    onFocus={() => {
                        if (!mobileNumber) {
                            this.setState({mobileNumber: '+1'});
                            props.onInputChange(props.id, {name: 'mobileNumber', value: '+1'});
                        }
                    }}
                    onChange={({target}) => {
                        this.setState({mobileNumber: target.value})
                        props.onInputChange(props.id,target)
                    }}
                />
            </div>
            {showNameFields && (
            <React.Fragment>
            <div className="col">
                {mobileFullForm && <Label className="invite-m-label">First Name <span className="invite-m-optional">(Optional)</span></Label>}
                <Input type="text" name="firstName" placeholder="e.g. Jane"
                    onChange={({target}) => {
                        if(specialChar.test(target.value)){
                            this.setState({firstName:true, fName: target.value})
                        }else{
                            this.setState({firstName:false, fName: target.value})
                            props.onInputChange(props.id,target)}
                        }
                    }
                    value={props.memberData ? fName:''}
                />
                {firstName===true && <div className="input-error-msg-field">Please remove any numbers or special characters.</div>}
            </div>
            <div className="col">
                {mobileFullForm && <Label className="invite-m-label">Last Name <span className="invite-m-optional">(Optional)</span></Label>}
                <Input type="text" name="lastName" placeholder="e.g. Doe"
                    onChange={({target}) => {
                        if(specialChar.test(target.value)){
                            console.log(target, target.name, target.value)
                            this.setState({lastName:true, lName: target.value})
                        }else{
                            this.setState({lastName:false, lName: target.value})
                            props.onInputChange(props.id,target)}
                        }
                    }
                    value={props.memberData ? lName:''}
                />
                {lastName===true && <div className="input-error-msg-field">Please remove any numbers or special characters.</div>}
            </div>
            </React.Fragment>
            )}
        </div>
        )
    };
}

